import { useLocation, useNavigate } from 'react-router-dom';
import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { getLesson } from '../../store/lessonSlice';
import { getQuestion, removeAddPreview, statusDeleteQuestion } from '../../store/questionSlice';
import DOMPurify from 'dompurify';
import CustomizerContext from '../../_helper/Customizer';


const QuestionTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const removePreview = () => dispatch(removeAddPreview())
  const location = useLocation();
  const storeVar = useSelector(state => state.question)
  const { layoutURL } = useContext(CustomizerContext);
  const [mainId, setmainId] = useState('')
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,

  });
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");
    setmainId(id);
    dispatch(getQuestion(id))
  }, [location.search]);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getLesson(formVar.limit, offset, formVar.status, formVar.keyword))
  };


  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(statusDeleteQuestion(data._id))
        }
      });
  }


  const handleAddNavigationClick = () => {
    removePreview();
    // navigate('/add-questions/' + layoutURL + '?id=' + mainId)
    navigate('/add-questions/' + layoutURL + '?id=' + mainId + '&type=' + type)
  }


  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="8">
              </Col>
              <Col md="2">
                <Btn attrBtn={{ color: 'warning-gradien', className: 'w-100', size: 'sm', onClick: () => window.location.reload() }} >
                  Reload
                </Btn>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: handleAddNavigationClick }} >
                    Add Questions
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Question in English</th>
                  <th scope='col'>Question in Bengali</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.questionData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td
                      className="questionImage"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.questionEnglish, {
                          ADD_TAGS: ['img'],
                          ADD_ATTR: ['src', 'alt', 'width', 'height', 'style'],
                        }),
                      }}
                    ></td>
                    <td
                      className="questionImage"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.questionBengali, {
                          ADD_TAGS: ['img'],
                          ADD_ATTR: ['src', 'alt', 'width', 'height', 'style'],
                        }),
                      }}
                    ></td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => window.open('/edit-questions/' + layoutURL + '?id=' + item._id)}></i>
                          {/* <i className="fa fa-edit fa-lg" onClick={(e) => navigate('/edit-questions/' + layoutURL + '?id=' + item._id)}></i> */}
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.questionData.length <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totallesson > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totallesson}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
    </Fragment>
  );
};

export default QuestionTable;
